import React from 'react';
import { useSelector } from 'react-redux';

import WpAvatar from 'Wpds/components/avatar/WpAvatar';

import './FeedbackTeammateInfo.scss';

type Props = {
  isEditFeedback: boolean;
};

function FeedbackTeammateInfo({ isEditFeedback }: Props) {
  const workspaceName = useSelector(state => state.workspace.name);

  const teammate = useSelector(state => {
    const workspaceMembers = state.workspace.users;
    return workspaceMembers?.find(({ id }) => id !== state.user.id);
  });

  const teammateName = teammate?.firstName || teammate?.fullName || teammate?.email || workspaceName;

  const title = isEditFeedback ? `Edit your feedback for ${teammateName}` : `Share your feedback with ${teammateName}`;

  return (
    <div className="FeedbackTeammateInfo d-flex align-items-center pb-5">
      <WpAvatar avatar={teammate?.avatar} size="xl" />
      <div className="d-flex flex-column ml-4">
        <div className="FeedbackTeammateInfo__title">{title}</div>
      </div>
    </div>
  );
}

export default FeedbackTeammateInfo;
